import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/indices/ranges", null, {}, {
    "Accept": ["application/json"]
  });
}
export function rebuildIndexSet(indexSetId) {
  return __request__("POST", `/system/indices/ranges/index_set/${indexSetId}/rebuild`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function rebuild() {
  return __request__("POST", "/system/indices/ranges/rebuild", null, {}, {
    "Accept": ["application/json"]
  });
}
export function rebuildIndex(index) {
  return __request__("POST", `/system/indices/ranges/${index}/rebuild`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function show(index) {
  return __request__("GET", `/system/indices/ranges/${index}`, null, {}, {
    "Accept": ["application/json"]
  });
}
